import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

const MIN_DURATION_TO_ROUND_UP_MS = 3000;

@Pipe({ name: 'formatTimeSpent' })
export class FormatTimeSpentPipe implements PipeTransform {
    transform(timeSpent: number, roundUpShortDurations = false): string {
        const tempTime = moment.duration(timeSpent);
        const hours = Math.floor(tempTime.asHours());
        let minutes = tempTime.minutes();

        if (roundUpShortDurations && timeSpent > MIN_DURATION_TO_ROUND_UP_MS && hours === 0 && minutes === 0) {
            minutes = 1;
        }

        return hours + 'h ' + minutes + 'min';
    }
}
